/**
 * The address typed in «Conectar un buzón nuevo» and its IMAP user almost always share a
 * domain: Hostinet logs in with the address itself. On 2026-09-23 `compras@` went into
 * production as `compras@ferreteriacubas.es` with the user `compras@ferreteriacubas.com`.
 * The `.es` domain does not exist, and every redirect would have left from it
 * (`Resent-From` and the envelope sender), so the form says so before saving.
 *
 * A warning and not a block: an alias whose login is another account is legitimate.
 */

/** The domain after the last `@`, lowercased. Null when there is no domain. */
export function domainOf(value: string): string | null {
  const text = value.trim();
  const at = text.lastIndexOf('@');
  if (at < 1) return null;
  return text.slice(at + 1).toLowerCase() || null;
}

/**
 * What to tell the person when the address and the user are of different domains, or
 * null. A user without `@` (some providers log in with a bare name) says nothing about
 * the domain, so it raises nothing.
 */
export function addressDomainWarning(address: string, username: string): string | null {
  const addressDomain = domainOf(address);
  const userDomain = domainOf(username);
  if (!addressDomain || !userDomain || addressDomain === userDomain) return null;
  return `La dirección es de ${addressDomain} y el usuario de ${userDomain}. Casi siempre son el mismo dominio: revísala antes de guardar, porque los reenvíos saldrán desde ella.`;
}
